module.exports = __webpack_public_path__ + "img/32a-indicadores-produtividade-media-geral.8076133c.png";